module.exports = __webpack_public_path__ + "static/media/IMG_4515a.742cc8f8.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/lostWorld/IMG_4515a.JPG
// module id = 173
// module chunks = 0